/* eslint-disable */
import $ from "jquery";
import Vue from "vue";
import "slick-slider";
import Articles from './components/Articles.vue';
import Cookies from 'js-cookie';

if (document.getElementById('app')) {
    new Vue({
        el: '#app',
        components: { Articles },
    });
}

import lozad from "lozad";

// usage: log('inside coolFunc',this,arguments);
// http://paulirish.com/2009/log-a-lightweight-wrapper-for-consolelog/
window.log = function() {
    log.history = log.history || []; // store logs to an array for reference
    log.history.push(arguments);
    if (this.console) {
        window.console.log(Array.prototype.slice.call(arguments));
    }
};

// new Vue({
//   el: "#app",
//   components: { Articles, Posts, Projects }
// });

window.jQuery = window.$ = require("jquery");

//const observer = lozad();
//observer.observe();

//Toggle bulma mobile nav classes on click
$(document).ready(function() {
    $(".navbar-burger").click(function() {
        $(".navbar-burger").toggleClass("is-active");
        $(".header-nav").toggleClass("is-active");
        $(".navbar-menu").toggleClass("is-active");

        if ($(".navbar-burger").first().hasClass('is-active')) {
            $('body').addClass("fixed-position");
        } else {
            $('body').removeClass("fixed-position");
        }

    });

    $('.sales-slider').slick({
        dots: true,
        infinite: true,
        autoplay: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [{
                breakpoint: 900,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                },
            },
            {
                breakpoint: 728,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 550,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],

    }).on('setPosition', function (event, slick) {
        // slick.$slides.css('height', slick.$slideTrack.height() + 'px');
    });    
});


new CookiesEuBanner(function() {
    // The code to launch when user accept cookies
    if (gaFixus) {
        gtag('config', gaFixus);    
        console.log("gtag fixus")
    }

    if (gaClient) {
        gtag('config', gaClient);    
        console.log("gtag client")
    }

}, true);